import React, { useEffect, useState } from "react";
import Accordian, { AccordianItem } from "./Accordian";
import CompanyLogo from "../../common/CompanyLogo";
import Api_Instance from "../../api/Api_Instance";
import { faqsEndPoints } from "../../api/endpoints";
import toast from "react-hot-toast";

const Faqs = () => {
  const [FAQs, setFAQs] = useState();
  const api = Api_Instance.unAuth();
  const GetFaqs = async () => {
    try {
      const FaqsResponse = await api("GET", faqsEndPoints?.GET_FAQS_API);
      setFAQs(FaqsResponse?.data?.data);
    } catch (error) {
      console.log(error);
      // throw new Error(error);
    }
  };
  useEffect(() => {
    GetFaqs();
  }, []);
  return (
    <>
      <CompanyLogo title={"FAQ'S"} subtitle={"FAQ's"} />
      <div className="w-full md:w-[91%] xl:[84%] 2xl:w-[75%] mx-auto mt-4 p-2">
        <h1 className="md:text-3xl font-semibold">
          Frequently Asked <span className="text-primaryColor">Questions</span>
        </h1>
        <hr className="w-full mt-4" />
      </div>
      <div>
        {FAQs ? (
          <Accordian className="w-full md:w-[91%] xl:[84%] 2xl:w-[75%] mx-auto mt-4 grid grid-cols-1 md:grid-cols-2 gap-x-5 p-2">
            {FAQs?.map((faqs, index) => (
              <AccordianItem
                key={index}
                value={index + 1}
                trigger={faqs?.question}
              >
                {faqs?.answer}
              </AccordianItem>
            ))}
          </Accordian>
        ) : (
          <div>NO FAQs Found</div>
        )}
      </div>
    </>
  );
};

export default Faqs;
